module.exports = "https://coursera_assets.s3.amazonaws.com/images/996fca8f6118c06b9bfe280ce269d80e.png";